"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const Container = styled_1.default.div({
    overflow: 'hidden',
}, ({ isExpanded = true, containerHeight = 0 }) => ({
    height: containerHeight,
    transition: isExpanded ? 'height 250ms ease-out' : 'height 150ms linear',
}));
function Accordion({ children, isExpanded = true, className, }) {
    const containerRef = (0, react_1.useRef)(null);
    const [containerHeight, setContainerHeight] = (0, react_1.useState)(isExpanded ? 'auto' : 0);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        setTimeout(() => {
            var _a;
            const scrollHeight = ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
            setContainerHeight(scrollHeight);
        }, 0);
        if (!isExpanded) {
            const scrollHeight = ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) || 0;
            setContainerHeight(scrollHeight);
            setTimeout(() => {
                setContainerHeight(0);
            }, 0);
        }
        function onTransitionEnd() {
            if (isExpanded) {
                setContainerHeight('auto');
            }
        }
        (_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('transitionend', onTransitionEnd);
        return () => {
            var _a;
            (_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('transitionend', onTransitionEnd);
        };
    }, [isExpanded]);
    return (react_1.default.createElement(Container, { "data-testid": "accordion-container", ref: containerRef, isExpanded: isExpanded, className: className, containerHeight: containerHeight }, children));
}
exports.default = Accordion;
